<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<!-- Creator: CorelDRAW 2020 (64-Bit) -->
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 3598.32 3598.32"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
 <defs>
  <style type="text/css">
   <![CDATA[
    .fil0 {fill:black;fill-rule:nonzero}
   ]]>
  </style>
 </defs>
 <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
  <g>
   <path class="fil0" d="M1622.72 2857.56l352.81 0 0 -352.81 -352.81 0 0 352.81 0 0zm176.41 -2822.29c-973.97,0 -1763.86,789.89 -1763.86,1763.92 0,973.97 789.89,1763.86 1763.86,1763.86 974.03,0 1763.92,-789.89 1763.92,-1763.86 0,-974.03 -789.89,-1763.92 -1763.92,-1763.92l0 0zm0 3175.1c-777.9,0 -1411.18,-633.28 -1411.18,-1411.18 0,-777.89 633.28,-1411.18 1411.18,-1411.18 777.89,0 1411.18,633.29 1411.18,1411.18 0,777.9 -633.29,1411.18 -1411.18,1411.18l0 0zm0 -2469.54c-389.55,0 -705.49,315.94 -705.49,705.55l352.68 0c0.06,-194.8 158.07,-352.81 352.81,-352.81 194.8,0 352.81,158.01 352.81,352.81 0,352.81 -529.22,308.75 -529.22,882.03l352.81 0c0,-396.95 529.15,-441.01 529.15,-882.03 0,-389.61 -315.94,-705.55 -705.55,-705.55z"/>
  </g>
 </g>
</svg>
